import { useState, useEffect } from 'react';

/**
 * Hook to fetch available records for an association when in editable mode. 
 * @param {*} config 
 * @param {*} isEditable 
 * @returns 
 */
export const useAvailableRecords = (config, isEditable) => {
    const [allRecords, setAllRecords] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!isEditable || !config.isEditable || !config.availableRecordsEndpoint) {
            return;
        }

        setLoading(true);
        fetch(config.availableRecordsEndpoint)
            .then(res => res.json())
            .then(responseData => {
                const records = Array.isArray(responseData) ? responseData : (responseData.results || []);
                setAllRecords(records);
            })
            .catch(err => console.error(`Error fetching records for ${config.key}:`, err))
            .finally(() => {
                setLoading(false);
            });
    }, [isEditable, config.isEditable, config.availableRecordsEndpoint, config.key]);

    return { allRecords, loading };
};
